import React, { Component } from "react";
import { reduxForm, Field } from "redux-form";
import { Link } from "react-router-dom";

import TextField from "../../../components/SimpleTextField/TextField";
import CheckboxField from "../../../components/SimpleCheckboxField/CheckboxField";
import PasswordField from "../../../components/PasswordField/PasswordField";

import { required, validEmail } from "../../../helpers/validators";
import { routes } from '../../../config/routes';

const requiredEmail = required("email address");
const checkValidEmail = validEmail("email address");
const requiredPass = required("password");
class LoginForm extends Component {
  render() {
    const { handleSubmit, loginTitle } = this.props;
    return (
      <form className="form-signin" onSubmit={handleSubmit}>
        <div className="top-form">
          <Field
            id="email"
            name="email"
            type="text"
            component={TextField}
            label="Email address"
            validate={[requiredEmail, checkValidEmail]}
            wrapperClasses={'form-group'}
          />
          <Field
            id="password"
            name="password"
            component={PasswordField}
            label="Password"
            validate={[requiredPass]}
            wrapperClasses={'form-group'}
          />
          <Field
            id="checkbox"
            name="checkbox"
            type="checkbox"
            component={CheckboxField}
            label="Remember me"
            wrapperClasses={'chckbox'}
          />
          <div className="form-group btn-group">
            <button className="cmn-btn" type="submit">Login</button>
            <Link to={routes.FORGOT_PASSWORD} className="forgot-password">Forgotten Password</Link>
            {!loginTitle && <Link to={routes.SIGNUP} className="forgot-password">Register Now</Link>}
          </div>
        </div>
      </form>
    );
  }
}

LoginForm = reduxForm({
  form: "login_form"
})(LoginForm);

export default LoginForm;
